import { DataNodeModel } from "../../pages/editor/diagram/nodes/DataNodeModel";

// Return all the possible path to reach the given node
export const getAllPathsFromNode = (node: DataNodeModel|undefined): DataNodeModel[][] => {
  const allPaths: DataNodeModel[][] = [];
  if (node) {
    findPaths(node, [], allPaths);
  }
  return allPaths.map((path) => path.slice().reverse());
}

// Iterative method to find paths
export const findPaths = (node: DataNodeModel, path: DataNodeModel[] = [], allPaths: DataNodeModel[][] = []) => {
  path.push(node);
  const inPorts = node.getInPorts();
  if (inPorts.length === 0) {
    // Si le noeud n'a pas de port d'entrée, ajoute le chemin aux chemins trouvés
    allPaths.push([...path]);
  } else {
    inPorts.forEach(inPort => {
      Object.values(inPort.getLinks()).forEach(link => {
        const sourceNode = link.getSourcePort().getNode() as DataNodeModel;
        findPaths(sourceNode, path, allPaths);
      });
    });
  }
  path.pop();
};